// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Xml_parser = require("./Xml_parser.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Xml_to_React = require("./Xml_to_React.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");

var make = React.memo(function (props) {
      var xmlStr = props.xmlStr;
      var rndErr = function (errorMsg, xmlStr) {
        return React.createElement(Expln_React_Column.make, {
                    children: Caml_option.some(null)
                  }, "An error happened when rendering description:", React.createElement("pre", {
                        style: {
                          color: "red"
                        }
                      }, errorMsg), "Showing raw content:", React.createElement("pre", {
                        style: {
                          whiteSpace: "pre-wrap",
                          overflowWrap: "break-word"
                        }
                      }, xmlStr));
      };
      var msg = Xml_parser.parseStr("<div>" + xmlStr + "</div>");
      if (msg.TAG !== /* Ok */0) {
        return rndErr(msg._0, xmlStr);
      }
      var msg$1 = Xml_to_React.xmlToReactElem(msg._0);
      if (msg$1.TAG === /* Ok */0) {
        return React.createElement("div", {
                    style: {
                      margin: "0px",
                      padding: "0px"
                    }
                  }, msg$1._0);
      } else {
        return rndErr(msg$1._0, xmlStr);
      }
    });

exports.make = make;
/* make Not a pure module */
